export const LEGAL_VERSION = "2026-07-22";
export const PRIVACY_CONTACT_EMAIL = "hertierdefla@gmail.com";
export const CONTROLLER_NAME = "Maurizio Ciocca";
export const CONTROLLER_ADDRESS = "Rotwandstraße 6, 81539 Munich, Germany";
